// extracted by mini-css-extract-plugin
module.exports = {"information-content":"InformationPage_information-content__1NLRP","title":"InformationPage_title__2jvYO","description":"InformationPage_description__2PoH6"};